import { http } from './http';
import { ROUTES } from './config';
import type { SiteConfig, SiteInput, SitePublicResponse } from '../types/domain';

/** SiteController client (manager+ get/upsert; /public is anonymous). */
export const siteApi = {
  get(): Promise<SiteConfig> {
    return http.get(ROUTES.site.base);
  },

  getPublic(): Promise<SitePublicResponse> {
    return http.get(ROUTES.site.public, { anonymous: true });
  },

  /** Upsert — a tenant has exactly one site config. Returns {id} on first write, nothing after. */
  update(body: SiteInput): Promise<{ id: string } | void> {
    return http.put(ROUTES.site.base, body);
  },
};
